import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';

import {
  ProcessedMonitoringStatus,
  ProcessedShouldMonitor,
  RawMonitoringStatus,
} from '../types/AuthorConfiguredDCRTypes';

export function getMonitorDataChangesStatusForViewSpace(
  status: ProcessedMonitoringStatus | undefined
): string {
  switch (status) {
    case ProcessedMonitoringStatus.CannotBeMonitored:
      return Messages.dataChangeRadarCannotBeMonitored();
    case ProcessedMonitoringStatus.Monitored:
      return Messages.dataChangeRadarMonitored();
    case ProcessedMonitoringStatus.NotMonitored:
      return Messages.dataChangeRadarNotMonitored();
    case ProcessedMonitoringStatus.Pending:
      return Messages.dataChangeRadarPending();
    case ProcessedMonitoringStatus.MonitoredCannotStop:
      return Messages.dataChangeRadarMonitoredCannotStop();
    case ProcessedMonitoringStatus.Loading:
      return Messages.dataChangeRadarLoading();
    default:
      return Messages.dataChangeRadarUnknown();
  }
}

export function getMonitorDataChangesStatusTooltipContentForViewSpace(
  status: ProcessedMonitoringStatus | undefined
): string {
  switch (status) {
    case ProcessedMonitoringStatus.CannotBeMonitored:
      return Messages.dataChangeRadarCannotBeMonitoredGeneralErrorTooltip();
    case ProcessedMonitoringStatus.Monitored:
      return Messages.dataChangeRadarMonitoredTooltip();
    case ProcessedMonitoringStatus.NotMonitored:
      return Messages.dataChangeRadarNotMonitoredTooltip();
    case ProcessedMonitoringStatus.Pending:
      return Messages.dataChangeRadarPendingTooltip();
    case ProcessedMonitoringStatus.MonitoredCannotStop:
      return Messages.dataChangeRadarMonitoredCannotStopTooltip();
    case ProcessedMonitoringStatus.Loading:
        return Messages.dataChangeRadarLoadingTooltip();
    default:
      return Messages.dataChangeRadarUnknownTooltip();
  }
}

export function showMonitorDataChangesInViewSubspace(): boolean {
  const state = getAppStore().getState();
  return SessionSiteSelectors.dataMonitoringAuthorConfigurationUIEnabled(state);
}

export function convertToProcessedMonitoringStatus(rawMonitoringStatus: RawMonitoringStatus): ProcessedMonitoringStatus {
  switch (rawMonitoringStatus) {
    case RawMonitoringStatus.CannotBeMonitored:
      return ProcessedMonitoringStatus.CannotBeMonitored;
    case RawMonitoringStatus.Monitored:
      return ProcessedMonitoringStatus.Monitored;
    case RawMonitoringStatus.NotMonitored:
      return ProcessedMonitoringStatus.NotMonitored;
    case RawMonitoringStatus.Pending:
      return ProcessedMonitoringStatus.Pending;
    case RawMonitoringStatus.MonitoredCannotStop:
      return ProcessedMonitoringStatus.MonitoredCannotStop;
    default:
      return ProcessedMonitoringStatus.Unknown;
  }
}

export function convertToProcessedShouldMonitor(hasShouldMonitor: boolean, rawShouldMonitor: boolean): ProcessedShouldMonitor {
  if (!hasShouldMonitor) {
    return ProcessedShouldMonitor.Unconfigured;
  }
  return rawShouldMonitor ? ProcessedShouldMonitor.ShouldMonitor : ProcessedShouldMonitor.ShouldNotMonitor;
}
